<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <v-icon v-if="showIcon" color="primary">mdi-help</v-icon>
        {{ text }}
        <template v-if="dvojtecka == true">: </template>
        <b :class="smallText == true ? 'text-caption font-italic' : ''">{{ value }}</b>
        <br />
      </span>
    </template>
    <span :class="smallText == true ? 'text-caption font-italic' : ''">
      <template v-if="showIcon == true">
        <pre>{{ tooltip }}</pre>
      </template>
      <template v-else>
        {{ tooltip }}
      </template>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    showIcon: {
      type: Boolean,
      defualt: false,
      require: false,
    },
    text: {
      type: String,
      default: "",
      require: true,
    },
    value: {
      type: String,
      default: "",
      require: true,
    },
    tooltip: {
      type: String,
      default: "",
      require: true,
    },
    dvojtecka: {
      type: Boolean,
      default: true,
      require: false,
    },
    smallText: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
};
</script>

<style scoped></style>
